
import React from 'react'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';
import StatCounter from 'smartstream-widgets/controls/StatCounter/StatCounter'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme';

const styles = (theme: Theme) =>  createStyles({
  root: {
    width: 'auto'
  },
  genericScoresClass: {
    color: theme.palette.text.secondary,
    fontFamily: `${theme.typography.variantFontFamily},${theme.typography.fontFamily}`,
    fontSize: 'inherit',
    fontWeight: 700,
    lineHeight: 'inherit'
  },
  separator: {
    color: theme.palette.text.primary,
    fontFamily: `${theme.typography.variantFontFamily},${theme.typography.fontFamily}`,
    fontSize: 'inherit',
    fontWeight: 700,
    margin: `0px 0.2em`,
    lineHeight: 'inherit'
  },
  highlight: {
    color: theme.palette.text.primary
  },
  teamSide: {},
  teamRecords: {}
})

type Props = {
  animationType: "slideUp" | "fadeIn",
  classes?: {
    [K in string]: string
  },
  leftScore: number,
  middleScore?: number | null,
  rightScore: number,
  separator?: string,
  highlight?: "higher" | "lower" | "both",
  animationDuration?: number
}

export function SimpleScores (props: Props) {
  const {
    animationType,
    classes,
    leftScore,
    middleScore,
    rightScore,
    separator = ' - ',
    highlight = 'both',
    animationDuration = 400
  } = props

  const middleScoreIsSettled = typeof middleScore === 'number'

  const getHighlightClass = (side: string): string => {
    if (middleScoreIsSettled) {
      return classes.highlight // highlight has not sense when there are 3 scores
    }
    if (leftScore === rightScore || highlight === 'both') return classes.highlight

    let optionSide

    if (highlight === 'higher') {
      optionSide = rightScore > leftScore ? 'right' : 'left'
    } else if (highlight === 'lower') {
      optionSide = leftScore > rightScore ? 'right' : 'left'
    }
    return optionSide === side ? classes.highlight : ''
  }
  return (
    <Grid container wrap='nowrap' className={`${classes.root} ${classes.teamSide}`} data-testid="simple-scores-container">
      <StatCounter
        animationDuration={animationDuration}
        animationType={animationType}
        align={'center'}
        className={`${classes.genericScoresClass} ${getHighlightClass('left')} ${classes.teamRecords}`}
        stat={leftScore}
      />
      {middleScoreIsSettled &&
        <>
          <Typography className={classes.separator}>{separator}</Typography>
          <StatCounter
            animationDuration={animationDuration}
            animationType={animationType}
            align={'center'}
            className={`${classes.genericScoresClass} ${getHighlightClass('middle')}`}
            stat={middleScore}
          />
        </>
      }
      <Typography className={classes.separator}>{separator}</Typography>
      <StatCounter
        animationDuration={animationDuration}
        animationType={animationType}
        align={'center'}
        className={`${classes.genericScoresClass} ${getHighlightClass('right')} ${classes.teamRecords}`}
        stat={rightScore}
      />
    </Grid>
  )
}

export default withStyles(styles, { name: 'SimpleScores', defaultTheme: getDefaultTheme })(SimpleScores)
